export default function (state, value) {
    state.loading = false;
    state.items = value;
    state.items.forEach(i=>{
        switch (i.Type){
            case 1:
                state.admin = true;
                break;
            case 4:
                state.admin = true;
                break;
            case 8:
                state.admin = true;
                break;
            case 9:
                state.admin = true;
                break;
            case 46:
                state.admin = true;
                break;
            case 52:
                state.admin = true;
                break;
            case 80:
                state.finances = true;
                state.financesPayments = true;
                break;
            case 102:
                state.finances = true;
                state.financesStatements = true;
                break;
            case 103:
                state.finances = true;
                state.financesStatements = true;
                break;
            case 135:
                state.finances = true;
                state.financesRegulars = true;
                break;
            case 143:
                state.finances = true;
                state.financesInvoices = true;
                break;
            case 159:
                state.finances = true;
                state.financesCertificates = true;
                break;
            case 113:
                state.admin = true;
                break;
            case 124:
                state.admin = true;
                break;
            case 166:
                state.admin = true;
                break;
            case 167:
                state.admin = true;
                break;
        }
    })
}